import React, { FC } from "react";
import { Stack as MuiStack, StackProps } from "@mui/material";

const Stack: FC<StackProps> = (props) => <MuiStack {...props} />;

export default Stack;
